module.exports = __webpack_public_path__ + "img/clothing60.cbe45f39.jpg";